// Select2 "tags" use the typed text as the option value, so a new contact named
// "5123" would be indistinguishable from the existing record with id 5123.
// Prefix new tags so the server can tell them apart (must match RecordId::NEW_PREFIX).
export const NEW_TAG_PREFIX = 'new:'

export const createNewTag = (params) => {
  const term = (params.term || '').trim()
  if (term === '') return null

  return { id: `${NEW_TAG_PREFIX}${term}`, text: term }
}
